export function resolveConversationNavigation(origin, fallbackTab) {
  const hasOrigin = Boolean(origin?.moduleId);
  return {
    tab:hasOrigin ? origin.moduleId : (fallbackTab || "inbox"),
    openConversationTarget:hasOrigin || !fallbackTab,
  };
}